const constants = {
    general:{
      name: 'LotiColombia',
      serverURL: process.env.REACT_APP_SERVERURL
    },
    toolbarOptions: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],        
      [{ 'font': [] }],
      [{ 'align': [] }],
      ['clean']                                  
    ]
  };
  
  export default constants;